import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { IMAGES } from '../lib/constants';
type Buyer = {
  name: string;
  place: string;
  minutes: number;
};
const BUYERS: Buyer[] = [{
  name: 'Dra. Mariana G.',
  place: 'Bogotá, Colombia',
  minutes: 2
}, {
  name: 'Dr. Andrés R.',
  place: 'Ciudad de México, México',
  minutes: 4
}, {
  name: 'Dra. Camila S.',
  place: 'Córdoba, Argentina',
  minutes: 6
}, {
  name: 'Dr. Javier T.',
  place: 'Santiago, Chile',
  minutes: 3
}, {
  name: 'Dra. Lucía F.',
  place: 'Lima, Perú',
  minutes: 7
}, {
  name: 'Dr. Ricardo M.',
  place: 'Guayaquil, Ecuador',
  minutes: 5
}, {
  name: 'Dra. Paola V.',
  place: 'Montevideo, Uruguay',
  minutes: 8
}, {
  name: 'Dr. Sergio L.',
  place: 'Valencia, España',
  minutes: 4
}, {
  name: 'Dra. Daniela C.',
  place: 'San José, Costa Rica',
  minutes: 9
}, {
  name: 'Dr. Emilio N.',
  place: 'Asunción, Paraguay',
  minutes: 6
}];
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const showTimer = setTimeout(() => {
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), 6000);
    }, 7000);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, []);
  useEffect(() => {
    const cycle = setInterval(() => {
      setIndex(prev => (prev + 1) % BUYERS.length);
      setVisible(true);
      setTimeout(() => setVisible(false), 6000);
    }, 15000);
    return () => clearInterval(cycle);
  }, []);
  const buyer = BUYERS[index];
  return <div className="pointer-events-none fixed inset-x-3 bottom-[6.5rem] z-40 sm:inset-x-auto sm:bottom-24 sm:left-4 sm:max-w-[21rem]" data-id="element-42" data-mp="1p7elhahb33vm">
      <AnimatePresence mode="wait" data-id="element-43" data-mp="rqzdxgkfouxq">
        {visible ? <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 18,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.97
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="flex items-center gap-3 rounded-2xl border border-navy-100 bg-white p-2.5 shadow-soft" role="status" data-id="element-44" data-mp="wr3vzb0zpxq2">
            <img src={IMAGES.mockup} alt="" className="h-12 w-12 shrink-0 rounded-xl bg-cream object-cover" data-id="element-45" data-mp="24s7x1dd1xq5n" />
            <div className="min-w-0 flex-1" data-id="element-46" data-mp="1h4zzjhlv7le6">
              <p className="truncate text-[12.5px] font-bold text-navy-900" data-id="element-47" data-mp="1c53wplowm007">{buyer.name}</p>
              <p className="text-[11.5px] leading-snug text-navy-500" data-id="element-48" data-mp="1q43jensuw4tq">
                de {buyer.place} acaba de comprar el <strong className="font-semibold text-navy-700" data-id="element-49" data-mp="1l3p9f07p2kt2">Sistema de Diagnóstico Facial</strong>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[10.5px] font-semibold text-gold-600" data-id="element-50" data-mp="31hfi6k9rdx91">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-51" data-mp="2wje1u73pwc19" />
                Compra verificada · hace {buyer.minutes} min
              </p>
            </div>
          </motion.div> : null}
      </AnimatePresence>
    </div>;
}